import { TaskStatus } from "../types";
import appClient from "../../common/services/AppClient";
import { UserModel } from "../types";
import { endpoints } from "../../../config";

export default class TaskStatusesService {
    uriPrefix = endpoints.tasksUrl + "taskstatuses";

    async getTaskStatuses(typeId: string) {
        const url = this.uriPrefix + `/type/${typeId}`;
        const resp = await appClient.get<TaskStatus[]>(url);
        return resp.mapErr((err) => new Error(err.data?.title));
    }

    async createTaskStatus(
        name: string,
        code: string,
        isSubtaskStatus: boolean,
        typeId: string,
        assignedUserIds: string[] | undefined = undefined,
    ) {
        const request = {
            name,
            code,
            typeId,
            assignedUserIds,
            isSubtaskStatus,
        };
        const url = endpoints.tasksUrl + "taskstatuses/new";
        return appClient.post<string>(url, request);
    }

    async editTaskStatus(statusId: string, name: string, code: string) {
        const request = {
            statusId,
            name,
            code,
        };
        const url = endpoints.tasksUrl + "taskstatuses/edit";
        return appClient.update(url, request);
    }

    async toggleTaskStatus(statusId: string) {
        const url = endpoints.tasksUrl + `taskstatuses/toggle/${statusId}`;
        return appClient.update(url);
    }
    async deleteTaskStatus(statusId: string) {
        const url = endpoints.tasksUrl + `taskstatuses/delete/${statusId}`;
        const resp = await appClient.post(url);
        return resp.mapErr((err) => new Error(err.data?.title));
    }

    async updateStatusDependencies(dependencies: object) {
        const url = endpoints.tasksUrl + "taskstatuses/updatedependencies";
        return appClient.post(url, dependencies);
    }

    async updateStatusActions(actions: object) {
        const url = endpoints.tasksUrl + "taskstatuses/updateactions";
        return appClient.post(url, actions);
    }

    async updateStatusAssignedUsers(taskStatusId: string, userIds: string[]) {
        const request = {
            taskStatusId,
            userIds,
        };
        const url = endpoints.tasksUrl + "taskstatuses/assignusers";
        return appClient.post(url, request);
    }

    async getUsersInProject(projectId: string) {
        const url = endpoints.tasksUrl + `users/project/${projectId}`;
        const resp = await appClient.get<UserModel[]>(url);
        return resp.mapErr((err) => new Error(err.data?.title));
    }
}
